import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getShadowProject } from '../services/getShadowProject.service';

export const loadShadowProject = createAsyncThunk(
  'shadowData/loadShadowProject',
  async (projectId, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const project = await getShadowProject(projectId, activeEmployerInfo);

    return project;
  }
);
